<div class="popup-overlay" [class.show]="visible" (click)="onBackdropClick($event)">
  <div class="popup-content" (click)="$event.stopPropagation()">
    <div class="popup-header">
      <h4 class="popup-title">
        <i
          class="me-2 fas"
          [ngClass]="selectedTab === 'invalidate' ? 'fa-ban' : 'fa-undo'">
        </i>
        {{ currentTitle }}
      </h4>

      <button type="button" class="btn-close" (click)="close()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body">
      <!-- Tabs -->
      <div class="tabs-container mb-3">
        <button
          type="button"
          class="tab-button"
          [class.active]="selectedTab === 'invalidate'"
          [disabled]="isSubmitting"
          (click)="setTab('invalidate')">
          <i class="fas fa-ban me-2"></i>
          Invalida
          <span class="badge bg-danger ms-2">{{ invalidableParcels.length }}</span>
        </button>

        <button
          type="button"
          class="tab-button"
          [class.active]="selectedTab === 'validate'"
          [disabled]="isSubmitting"
          (click)="setTab('validate')">
          <i class="fas fa-undo me-2"></i>
          Rivalida
          <span class="badge bg-loading-lists-success ms-2">{{ validableParcels.length }}</span>
        </button>
      </div>

      <div class="detail-section">
        <h5 class="section-title">
          <i [class]="sectionIcon"></i>
          {{ currentDescription }}
          <span class="badge ms-2" [ngClass]="badgeClass">{{ localParcels.length }}</span>
        </h5>

        <div class="waybills-container" *ngIf="hasItems">
          <div class="waybill-item" *ngFor="let parcel of localParcels; trackBy: trackByParcelCode">
            <div class="waybill-info">
              <i class="fas fa-box me-2"></i>
              <span class="waybill-code">{{ parcel.parcelCode }}</span>
            </div>

            <button
              type="button"
              class="btn-remove"
              (click)="removeParcel(parcel.parcelCode); $event.stopPropagation()"
              title="Rimuovi">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>

        <div class="empty-state" *ngIf="!hasItems">
          <i class="fas fa-exclamation-triangle text-warning"></i>
          <p class="mb-0">{{ emptyMessage }}</p>
        </div>
      </div>
    </div>

    <div class="popup-footer">
      <button type="button" class="btn btn-secondary me-2" (click)="close()">
        <i class="fas fa-times me-2"></i>
        Annulla
      </button>

      <button
        type="button"
        [class]="currentButtonClass"
        (click)="onConfirm()"
        [disabled]="!hasItems || isSubmitting">
        <i [class]="currentButtonIcon"></i>
        {{ currentButtonLabel }}
      </button>
    </div>
  </div>
</div>